import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import { LibraryItemIdsVersionedDTO } from '@/src/components/project/Library/types';
import { useToggle } from '@/src/hooks/useToggle';

import DeleteFile from './DeleteFile/DeleteFile';

interface DeleteMultipleProps {
  itemIdsVersioned: LibraryItemIdsVersionedDTO;
  inTrash: boolean;
}

const id = 'actionItem_deleteMultiple';

const DeleteMultiple = ({ itemIdsVersioned, inTrash }: DeleteMultipleProps) => {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);

  const handleClose = () => {
    toggleIsModalOpen(false);
  };

  return (
    <React.Fragment>
      <a onClick={toggleIsModalOpen} className="deleteFile" data-tooltip-id={id}>
        <i className="material-icons pd2">delete_outline</i>
        <Tooltip id={id} place="bottom" effect="solid">
          {inTrash ? 'Permanently Delete' : 'Delete'}
        </Tooltip>
      </a>
      {isModalOpen && (
        <ModalPortal>
          <DeleteFile
            itemIdsVersioned={itemIdsVersioned}
            isMultipleDelete={true}
            onClose={handleClose}
          />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default DeleteMultiple;
